// extracted by mini-css-extract-plugin
module.exports = {"singleNote":"SingleNote_singleNote__1VD1i","dataHeader":"SingleNote_dataHeader__3APWu","attachments":"SingleNote_attachments__3qsbr"};